import { FC } from "react";
import { useDispatch } from "react-redux";
import { SubMenuItem } from "src/constants/modules";
import { setClientId } from "src/store/slices/client/client.slice";
import { useOrdersList } from "../../context/OrderListContext";
import { useTranslation } from "react-i18next";
import { ScrollableMenu, ScrollableMenuItem } from "src/components";

interface OrderFilterSelectProps {
  items: SubMenuItem[];
}

export interface OrderFilterChipsLayoutProps {
  items: SubMenuItem[];
  selectedTab: string;
  onSelect: (item: SubMenuItem) => void;
}

const OrderFilterChips: FC<OrderFilterSelectProps> = ({ items }) => {
  const { selectedTab } = useOrdersList();
  const { t } = useTranslation();
  const menuItems = items.map((item) => ({
    value: item.route,
    label: (
      <>
        <span className="flex aspect-square w-4 items-center justify-center">{item.icon}</span>
        {t(item.label)}
      </>
    ),
  }));

  const dispatch = useDispatch();

  const onSelect = (item: SubMenuItem) => {
    if (selectedTab === item.route) return;
    dispatch(setClientId(item.key));
  };

  const onMenuSelect = ({ value }: ScrollableMenuItem) => {
    const item = items.find((i) => i.route === value);
    if (item) onSelect(item);
  };

  if (items.length <= 1) return null;

  return (
    <div className="border-border-subtle border-t border-b md:px-15 px-3">
      <ScrollableMenu
        items={menuItems}
        selectedItem={selectedTab}
        onSelect={onMenuSelect}
        classNames={{
          item: "relative p-5! duration-300 ease-out after:absolute after:inset-x-0 after:bottom-0 after:h-0.75 after:scale-x-0 after:bg-current after:transition-transform after:duration-300 after:ease-out",
          active: "border-b-0! after:scale-x-100",
        }}
      />
    </div>
  );
};

export default OrderFilterChips;
